import React, { useEffect, useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Grid,
  CardHeader,
  Avatar,
  IconButton,
} from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import moment from 'moment';
import { map, filter, trim } from 'lodash';
import { alertError } from '../../Util/Util';
import bonusProductAPI from '../../middleware/bonusProductAPI';
import CardTravelRoundedIcon from '@material-ui/icons/CardTravelRounded';
import FormatListBulletedRoundedIcon from '@material-ui/icons/FormatListBulletedRounded';
import { Skeleton } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import BonusProductQRCodeGroupProductCard from '../../components/BonusProduct/BonusProductQRCodeGroupProductCard';
import Swal from 'sweetalert2';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    width: '420px',
  },
  closeBtn: {
    textAlign: 'right',
  },
  products: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    alignItems: 'stretch',
    gap: theme.spacing(2),
  },
}));

const BonusProductQRCodeGroupDetail = (props) => {
  const { groupId, closeDrawer, refreshList } = props;
  const classes = useStyles();
  const [bonusProductQRCodes, setBonusProductQRCodes] = useState();
  const [groupQRCode, setGroupQRCode] = useState();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (groupId) {
      setIsLoading(true);

      getDetail().then(() => {
        setIsLoading(false);
      });
    }

    return () => {
      setBonusProductQRCodes(undefined);
      setGroupQRCode(undefined);
    };
  }, [groupId]);

  const getDetail = () => {
    return bonusProductAPI.getQRCodeGroupDetail(groupId).then(
      (rs) => {
        setBonusProductQRCodes(rs.bonusProductQRCodeList);
        setGroupQRCode({
          groupId: rs.groupId,
          groupSize: rs.groupSize,
          qrcodeValue: rs.qRCodeValue,
          createdDate: rs.createdDate,
        });
      },
      (error) => {
        alertError(error);
      },
    );
  };

  const handleClose = () => {
    closeDrawer();
  };

  const removeGroup = (qrcode) => {
    setIsLoading(true);

    bonusProductAPI
      .removeQRCodeGroup(groupId, qrcode)
      .then(
        () => {
          Swal.fire({
            title: '已將該 QRCODE 移出打包',
            icon: 'success',
          });
          getDetail();
          refreshList();
        },
        (error) => {
          alertError(error);
        },
      )
      .then(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className={classes.root}>
      <div className={classes.closeBtn}>
        關閉
        <IconButton onClick={handleClose}>
          <CancelIcon />
        </IconButton>
      </div>

      {isLoading && (
        <Grid
          container
          direction="column"
          justifycontent="flex-start"
          alignItems="stretch"
          spacing={3}>
          <Grid item xs={12}>
            <Skeleton variant="text" width={360} />
            <Skeleton variant="text" width={360} />
            <Skeleton variant="text" width={360} />
          </Grid>
        </Grid>
      )}

      {!isLoading && groupQRCode && (
        <Grid
          container
          direction="column"
          justifycontent="flex-start"
          alignItems="stretch"
          spacing={3}>
          <Grid item xs={12}>
            <Card variant="outlined">
              <CardHeader
                avatar={<CardTravelRoundedIcon />}
                title={<Typography variant="h5">打包序號</Typography>}
                subheader={`建立時間 ${moment(groupQRCode.createdDate).format(
                  'YYYY-MM-DD HH:mm:ss',
                )}`}
              />
              <CardContent>
                <Grid
                  container
                  direction="row"
                  justifycontent="space-around"
                  alignItems="stretch"
                  spacing={2}>
                  <Grid item xs={6}>
                    <Typography color="textSecondary">ID</Typography>
                    <Typography variant="h6">{groupQRCode.groupId}</Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography color="textSecondary">打包數量</Typography>
                    <Typography variant="h6">
                      {groupQRCode.groupSize}
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography color="textSecondary">QRCDOE</Typography>
                    <Typography variant="h6">
                      {groupQRCode.qrcodeValue}
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12}>
            <Card variant="outlined">
              <CardHeader
                avatar={
                  <Avatar>
                    <FormatListBulletedRoundedIcon />
                  </Avatar>
                }
                title={<Typography variant="h5">打包內容</Typography>}
              />

              <CardContent>
                <Grid
                  container
                  direction="row"
                  justifycontent="space-around"
                  alignItems="stretch"
                  spacing={2}>
                  <Grid item xs={4}>
                    <Typography
                      color="textSecondary"
                      style={{ textAlign: 'center' }}>
                      總計
                    </Typography>
                    <Typography variant="h5" style={{ textAlign: 'center' }}>
                      {groupQRCode.groupSize}
                    </Typography>
                  </Grid>

                  <Grid item xs={4}>
                    <Typography
                      color="textSecondary"
                      style={{ textAlign: 'center' }}>
                      歸戶
                    </Typography>
                    <Typography variant="h6" style={{ textAlign: 'center' }}>
                      {
                        filter(bonusProductQRCodes, (qrcode) => {
                          return (
                            trim(qrcode.linkDate) !== '' &&
                            trim(qrcode.useDate) === ''
                          );
                        }).length
                      }
                    </Typography>
                  </Grid>

                  <Grid item xs={4}>
                    <Typography
                      color="textSecondary"
                      style={{ textAlign: 'center' }}>
                      已使用
                    </Typography>
                    <Typography variant="h6" style={{ textAlign: 'center' }}>
                      {
                        filter(
                          bonusProductQRCodes,
                          (qrcode) => trim(qrcode.useDate) !== '',
                        ).length
                      }
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <div className={classes.products}>
                      {map(bonusProductQRCodes, (qrcode) => {
                        return (
                          <BonusProductQRCodeGroupProductCard
                            key={qrcode.qRCodeValue}
                            groupProduct={qrcode}
                            removeGroup={removeGroup}
                            isLoading={isLoading}
                          />
                        );
                      })}
                    </div>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default BonusProductQRCodeGroupDetail;
